import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { getFetch, postFetch } from "config/fetch";
import { baseURL } from "constants/baseUrl";
import * as queryKeys from "utils/queryKeys";

export const useGetBlacklistQuery = () =>
  useQuery({
    queryFn: () => getFetch(`${baseURL}/blacklist`),
    queryKey: [queryKeys.Blacklist],
    select: (data) => data?.data.blacklist,
  });

export const useCreateBlacklistMutation = (options) => {
  const query = useQueryClient();
  return useMutation({
    mutationFn: (data) => postFetch(`${baseURL}/blacklist`, "POST", {}, data),
    onSuccess: () => {
      query.invalidateQueries({ queryKey: [queryKeys.Blacklist] });
    },
    ...options,
  });
};

export const useUpdateFlaggedAccountMutation = (options) => {
  const query = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      postFetch(`${baseURL}/blacklist/status`, "PUT", {}, data),
    onSuccess: () => {
      query.invalidateQueries({ queryKey: [queryKeys.Blacklist] });
    },
    ...options,
  });
};
